import { type TimeStateMachine, TimeStates } from "@/models/time-control/timeStateTypes";
import type { StateFrom } from "xstate";
import SvgSyncIcon from "./icons/sync.module.svg";
import SvgSyncOffIcon from "./icons/sync_off.module.svg";

export const getTimeStateIcon = (timeState: StateFrom<TimeStateMachine>): JSX.Element | string => {
  if (timeState.matches(TimeStates.AUTO_REFRESH)) {
    if (timeState.context.modeOpts.isLocked) {
      return "lock_clock";
    }
    if (timeState.context.modeOpts.refreshRate === 0) {
      return <SvgSyncOffIcon />;
    }

    return <SvgSyncIcon />;
  }
  return "calendar_today";
};
